
import { get, post, postJson } from '@/utils/request'
export default {
  namespaced: true,
  state: {
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    // 获取时间列表
    async getSiftTimeListByErrorShiti(context, params) {
      const res = await get('/Study/error/shiti/getSiftTimeListByErrorShiti', params)
      return res
    },
    // 获取错题接口
    async getUserErrorCount(context, params) {
      const res = await postJson('/Study/error/shiti/getUserErrorCount', params)
      return res
    },
    // 错题整理拿数据
    async getShitiInfoByErrorShitiId(context, params) {
      const res = await get('/Study/error/shiti/getShitiInfoByErrorShitiId', params)
      return res
    },
    // 错题整理提交数据
    async updateUserErrorShitiInfo(context, params) {
      const res = await get('/Study/error/shiti/updateUserErrorShitiInfo', params)
      return res
    },
    // 查询 错题复练次数
    async getStudentPracticeAgainInfo(context, params) {
      const res = await get('/Study/error/shiti/getStudentPracticeAgainInfo', params)
      return res
    },
    // 查询 错题举一反三
    async getQListByShitiId(context, params) {
      const res = await get('/Study/error/shiti/getQListByShitiId', params)
      return res
    },
    // 校内错题整理拿数据
    async getUserErrorPictureInfo(context, params) {
      const res = await get('/Study/error/shiti/getUserErrorPictureInfo', params)
      return res
    },
    // 校内错题整理提交数据
    async updateUserErrorPictureInfo(context, params) {
      const res = await postJson('/Study/error/shiti/updateUserErrorPictureInfo', params)
      return res
    },
    // 校内错题举一反三
    async getSimilarShitiListByPicture(context, params) {
      const res = await get('/Study/error/shiti/getSimilarShitiListByPicture', params)
      return res
    }

  }
}

